import React from 'react';
import { Calendar, Instagram, Facebook } from 'lucide-react';
import { projects, companyInfo } from '../mockData';

const Projects = () => {
  return (
    <section id="projekte" className="bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Unsere <span className="text-[#C94A42]">Referenzen</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Einblicke in erfolgreich abgeschlossene Altbausanierungsprojekte
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {projects.map((project) => (
            <div
              key={project.id}
              className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 bg-white"
            >
              {/* Image */}
              <div className="relative h-72 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300" />
                
                {/* Year Badge */}
                <div className="absolute top-4 right-4 flex items-center space-x-2 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg">
                  <Calendar className="w-4 h-4 text-[#DC2626]" />
                  <span className="text-sm font-semibold text-gray-900">{project.year}</span>
                </div>

                {/* Content Overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-xl font-bold text-white mb-2">{project.title}</h3>
                  <p className="text-gray-200 text-sm leading-relaxed">{project.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Social Media CTA */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-[#DC2626] to-[#B91C1C] rounded-2xl p-12 text-center text-white shadow-2xl relative overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-10">
              <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)', backgroundSize: '30px 30px' }}></div>
            </div>

            <div className="relative z-10">
              <h3 className="text-3xl md:text-4xl font-bold mb-4">
                Folgen Sie unserer Sanierungs-Journey
              </h3>
              <p className="text-xl mb-8 text-white/90">
                Bleiben Sie auf dem Laufenden mit aktuellen Projekten, Vorher-Nachher-Bildern und Einblicken in unsere Arbeit
              </p>
              
              {/* Social Media Buttons */}
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <a
                  href={companyInfo.socialMedia.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center space-x-3 bg-white text-[#DC2626] px-8 py-4 rounded-full font-semibold text-lg hover:bg-gray-100 transition-all duration-300 hover:shadow-xl hover:scale-105 w-full sm:w-auto justify-center"
                >
                  <Instagram className="w-6 h-6" />
                  <span>Instagram folgen</span>
                </a>
                <a
                  href={companyInfo.socialMedia.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center space-x-3 bg-white text-[#DC2626] px-8 py-4 rounded-full font-semibold text-lg hover:bg-gray-100 transition-all duration-300 hover:shadow-xl hover:scale-105 w-full sm:w-auto justify-center"
                >
                  <Facebook className="w-6 h-6" />
                  <span>Facebook folgen</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;
